<template>
    <el-tabs class="demo-tabs">
        <el-tab-pane>
            <template #label>
                            <span class="custom-tabs-label">
                                <el-icon><Management /></el-icon>
                                <span>自建模版</span>
                            </span>
            </template>
            <div class="prescription_search">
                <el-row :gutter="15">
                    <el-col :span="18">
                        <el-form-item>
                            <el-input v-model="searchPreName" style="width: 100%" placeholder="输入关键字搜索处方模版" clearable/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <div class="addPlus">
                            <el-button type="primary" icon="Search" @click="searchPrescriptionList()">搜索</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="prescription_con" v-infinite-scroll="loadMorePrescription" style="overflow:auto">
                <div :class="choosPreId === item.id ? 'prescription_li_act flex_t_col':'prescription_li flex_t_col'"
                     v-for="(item, index) in prescriptionList" :key="index" @click="choosePrescription(item)">
                    <div class="prescription_title">
                        <el-row :gutter="15">
                            <el-col :span="18">
                                <span class="mrr10" v-if="item.isTop ==='0'"><el-tag type="danger">置顶</el-tag></span>
                                <span class="mrr10"><el-tag :type="item.billingType === '0' ? 'primary' : item.billingType === '1' ? 'success' : item.billingType === '2' ? 'warning' : 'danger'"
                                                            disable-transitions>{{ item.billingTypeName.substr(0,1) }}</el-tag></span>
                                <span class="font_weight font1_2rem">{{item.preName}}</span>
                            </el-col>
                            <el-col class="date_time_span" :span="6">
                                <span>{{item.createTime.substr(0,11)}}</span>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="prescription_con_li flex_c_top">
                        <div class="prescription_con_label">适应病症：</div>
                        <div class="prescription_con_info">{{item.instructions === null ? '无': item.instructions}}</div>
                    </div>
                    <div class="prescription_con_li flex_c_top">
                        <div class="prescription_con_med">{{item.medInfo}})</div>
                    </div>
                </div>

            </div>
        </el-tab-pane>
<!--        <el-tab-pane>-->
<!--            <template #label>-->
<!--                            <span class="custom-tabs-label">-->
<!--                                <el-icon><Opportunity /></el-icon>-->
<!--                                <span>处方库模版</span>-->
<!--                            </span>-->
<!--            </template>-->
<!--            <div class="prescription_search">-->
<!--                <el-row :gutter="15">-->
<!--                    <el-col :span="18">-->
<!--                        <el-form-item>-->
<!--                            <el-input style="width: 100%" placeholder="输入关键字搜索处方模版" clearable/>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="6">-->
<!--                        <div class="addPlus">-->
<!--                            <el-button type="primary" icon="Search" @click="getPrescriptionList()">搜索</el-button>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--            </div>-->
<!--            <div class="prescription_con" v-infinite-scroll="loadMorePrescription" style="overflow:auto">-->
<!--                <div :class="choosPreId === item.id ? 'prescription_li_act flex_t_col':'prescription_li flex_t_col'"-->
<!--                     v-for="(item, index) in prescriptionList" :key="index" @click="choosePrescription(item)">-->
<!--                    <div class="prescription_title">-->
<!--                        <el-row :gutter="15">-->
<!--                            <el-col :span="18">-->
<!--                                <span class="mrr10"><el-tag type="danger">置顶</el-tag></span>-->
<!--                                <span class="font_weight">{{ item.name }}</span>-->
<!--                            </el-col>-->
<!--                            <el-col class="date_time_span" :span="6">-->
<!--                                <span>2024-08-28</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                    <div class="prescription_con_li flex_c_top">-->
<!--                        <div class="prescription_con_label">适应病症：</div>-->
<!--                        <div class="prescription_con_info">{{item.instructions === null ? '无': item.instructions}}</div>-->
<!--                    </div>-->
<!--                    <div class="prescription_con_li flex_c_top">-->
<!--                        <div class="prescription_con_med">药材(12g),药材(12g),药材(12g),药材(12g),药材(12g),药材(12g),药材(12g),药材(12g)</div>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->
<!--        </el-tab-pane>-->
    </el-tabs>



    <!-- 打开双击选择的处方模版-->
    <el-dialog class="choosePrescriptionDialog" v-model="choosePrescriptionDialogVisible" title="导入处方" width="600" center>
<!--        <div class="cho_info">处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介处方模板简介</div>-->
        <div class="cho_title">您将要把【{{chooseSelfTempData.preName}}】导入到当前处方列表中，处方信息见下:</div>
        <div class="cho_line">
            <div class="cho_line_left">适应病症：</div>
            <div class="cho_line_right font_gray">{{chooseSelfTempData.instructions === null ? '无': chooseSelfTempData.instructions}}</div>
        </div>
        <div class="cho_line">
            <div class="cho_line_left">模版剂型：</div>
            <div class="cho_line_right font_gray">{{chooseSelfTempData.billingTypeName === null ? '颗粒': chooseSelfTempData.billingTypeName}}</div>
        </div>
        <div class="cho_line">
            <div class="cho_line_left">药材列表：</div>
            <div class="cho_line_right">{{chooseSelfTempData.medInfo === null ? '无': chooseSelfTempData.medInfo}}</div>
        </div>
        <div class="cho_title_info">请选择【替换】还是【追加】？</div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="replaceSelfTempChoose(chooseSelfTempData.billingType, chooseSelfTempData.preId)">替换已有药材</el-button>
                <el-button type="primary" @click="addSelfTempChoose(chooseSelfTempData.billingType, chooseSelfTempData.preId)">追加到已有药材</el-button>
            </div>
        </template>
    </el-dialog>

</template>


<script>
import prescription from "@/assets/scripts/components/prescription";
export default prescription;
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";
</style>